<template>
  <div class="page_content asset create" aria-label="Create Asset Page Content">
    <div>
      <div class="row page-heading border-0">
        <div class="col-9 input module_heading" :class="{invalid: $v.model.title.$error}">
          <span class="float-left icon-asset"></span>
          <input
            type="text"
            id="title"
            class="module_title ace_sec_txt"
            @blur="$v.model.title.$touch()"
            placeholder="Type asset name*"
            aria-label="type asset name"
            v-model.trim="model.title" v-focus>
        </div>
        <div class="col-3 btn_container">
          <div class="btns_group">
            <button class="btn btn-cancel" @click.stop="cancel" aria-label="close"><span class="icon-cross"></span></button>
            <button class="btn btn-primary" @click.stop="onSubmit(true)" :disabled="submitted" aria-label="done">done</button>
            <button class="btn btn-primary" @click.stop="onSubmit(false)" :disabled="submitted" aria-label="save">save</button>
          </div>
        </div>
      </div>
      <div class="page-content">
        <div class="row assessment-section" style="padding-left: 50px;">
          <div class="col-8 assessment-left-section">
            <div class="page-section">

              <div class="fld_row row">
                <div class="col-12 fld_label">
                  <label for="description" id="assetDescription">Asset Description</label>
                </div>
                <div class="col-12 fld_input">
                  <textarea rows="4" cols="50"
                    id="description"
                    placeholder="Type in the asset description..."
                    v-model="model.description"
                    aria-labelledby="assetDescription" style="width: 100%;">
                  </textarea>
                </div>
              </div>

              <div class="row" style="margin-top: 30px;">
                <div class="col-6" :class="{invalid: $v.model.uri.$error}">
                  <div class="fld_row row">
                    <div class="col-12 fld_label">
                      <label for="uri" id="assetUrl">URL</label>
                    </div>
                    <div class="col-12 fld_input">
                      <input
                        type="text"
                        id="uri"
                        placeholder="http://"
                        v-model.trim="model.uri"
                        aria-labelledby="assetUrl"
                        style="width: 100%;">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="fld_row row" style="padding-left: 30px;">
                    <div class="col-12 fld_label">
                      <label for="folder" id="folderName">Folder</label>
                    </div>
                    <div class="col-12 fld_input">
                      <select id="folder" v-model="model.owningLibrary" aria-labelledby="folderName" style="width: 100%;">
                        <option v-for="folder in folders" :value="{uuid: folder.uuid, displayName: folder.displayName}">{{ folder.displayName }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 assessment-right-section">
            <div class="page-section">
              <div class="page_section_row">
                <div class="heading">
                  <span class="ic-tag general mr-2"></span>
                  <span id="assetTags">Tags</span>
                  <span class="icon-pencil2 ml-2 ace_sec_txt" style="cursor: pointer;" @click="showAddTagPopup($event)"></span>
                </div>
                <div class="value">
                  <div class="tag-box-list">
                    <template v-for="(values, key, i) in model.appliedTagMap" class="tags_container">
                      <span class="tag" v-for="(tag, j) in values">
                      <span class="tag_name instructional_tag ace_sec_txt">{{tag.name}}</span>
                      </span>
                    </template>
                  </div>
                </div>
              </div>
              <div class="page_section_row row">
                <div class="col-12 heading border-0" style="">

                </div>
                <div class="col-12 folder-name" style="margin-top: 25px;">
                  <input type="checkbox" class="checkbox_fld" v-model="model.whiteListed" />
                  <label>Display inline</label>
                </div>
              </div>
            </div>
            <template>
              <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="asset-upload-popup">
      <b-modal ref="createSuccessModal" size="lg" :title="'1 asset created'" :header-bg-variant="'create-asset-success-modal'" ok-disabled cancel-diasbled hide-header-close hide-footer no-close-on-backdrop no-close-on-esc centered>
        <div class="create-asset-row">
          <span class="text-label">
          Click if you have finished creating asset
          </span>
          <span class="result-btn">
            <b-button @click="closeAndRedirect" class="btn" aria-label="ok"> ok </b-button>
          </span>
        </div>
        <div class="mt-1"></div>
        <div class="create-asset-row">
          <span class="text-label">
          Click if you want to create more asset
          </span>
          <span class="result-btn">
            <b-button @click="showCreate" class="btn continue" aria-label="continue creating asset"> continue creating asset </b-button>
          </span>
        </div>
      </b-modal>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
    <div>
      <data-loss-prompt ref="dataLossAlert" @okLose="okLose" @saveAndContinue="saveAndContinue"></data-loss-prompt>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import AddTagPopup from '../../tagging/components/AddTagPopup'
  import {required, minLength, url} from 'vuelidate/lib/validators'
  import '../../../assets/module/less/create_entity.less'
  import DataLossPrompt from '../../common/components/DataLossPrompt'
  import _ from 'lodash'
  Vue.use(Vuelidate)
  Vue.directive('focus', {
    inserted (el) {
      el.focus()
    }
  })

  var initialState = function () {
    return {
      model: {
        title: '',
        description: '',
        uri: '',
        owningLibrary: {},
        appliedTagMap: {},
        whiteListed: true,
        blackListed: true
      },
      folders: [],
      taggingEntityData: {},
      isShowTagPopup: false,
      submitted: false,
      nextPage: undefined,
      dirty: false,
      oldModel: {}
    }
  }

  export default {
    name: 'asset-create',
    components: {
      AddTagPopup,
      DataLossPrompt
    },
    data: () => {
      return initialState()
    },
    validations: {
      model: {
        title: {
          required,
          minLength: minLength(1)
        },
        uri: {
          required,
          url
        }
      }
    },

    mounted () {
      this.populateLibrary()
    },

    beforeRouteLeave (to, from, next) {
      if (this.dirty) {
        this.nextPage = next
        this.$refs.dataLossAlert.showPrompt()
        next(false)
      } else {
        next()
      }
    },

    methods: {
      ...mapActions([
        'loadLibrariesForUser',
        'createAsset'
      ]),

      populateLibrary () {
        const userId = localStorage.getItem('userid')
        this.loadLibrariesForUser(userId).then(learningSpaces => {
          this.folders = []
          for (var i = 0; i < learningSpaces.length; i++) {
            const learningSpace = learningSpaces[i]
            const permission = learningSpace.acelist[0].permission
            if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
              this.folders.push(learningSpace)
              if (learningSpace.category === 'Institute_Public') {
                this.model.owningLibrary = {uuid: learningSpace.uuid, displayName: learningSpace.displayName}
              }
            }
          }
          if (this.folders.length > 0 && _.isEmpty(this.model.owningLibrary)) {
            this.model.owningLibrary = {uuid: this.folders[0].uuid, displayName: this.folders[0].displayName}
          }
          this.$data.oldModel = _.cloneDeep(this.$data.model)
        })
      },

      showAddTagPopup (event) {
        this.isShowTagPopup = true
        this.taggingEntityData = {title: this.title, type: 'assets', appliedTagMap: this.model.appliedTagMap}
        setTimeout(() => {
          this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
        }, 500)
      },

      cancel () {
        this.$router.go(-1)
      },

      onSubmit (isDone) {
        this.$v.model.uri.$touch()
        if (this.$v.model.title.$error || this.$v.model.uri.$error) {
          return
        }
        this.dirty = false
        this.$refs.loadingModal.show()
        this.submitted = true
        // const appliedTagMap = {general: this.tags}
        const formData = {
          title: this.model.title,
          description: this.model.description,
          uri: this.model.uri,
          type: 'REMOTE',
          appliedTagMap: this.model.appliedTagMap,
          ancestor: this.model.owningLibrary.uuid,
          owningLibraryId: this.model.owningLibrary.uuid,
          whiteListed: this.model.whiteListed,
          blackListed: this.model.blackListed,
          isWhiteListed: this.model.whiteListed,
          isBlackListed: this.model.blackListed
        }
        this.createAsset(formData).then(res => {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Asset "' + this.model.title + '" created and saved successfully.'
          })
          this.$refs.loadingModal.hide()
          if (isDone) {
            if (this.nextPage) {
              this.$emit('resolveNext', this.nextPage)
            } else {
              this.$refs.createSuccessModal.show()
            }
          } else {
            this.submitted = false
          }
        })
      },

      closeAndRedirect () {
        this.$refs.createSuccessModal.hide()
        return this.$router.push({ name: 'results' })
      },

      showCreate () {
        this.$refs.createSuccessModal.hide()
        Object.assign(this.$data, initialState())
        this.populateLibrary()
        this.$v.model.uri.$reset()
        this.$v.model.title.$reset()
        $('#title').focus()
        this.$data.oldModel = _.cloneDeep(this.$data.model)
      },

      okLose () {
        this.$emit('resolveNext', this.nextPage)
      },

      saveAndContinue () {
        this.onSubmit(true)
      }
    },

    watch: {
      model: {
        handler () {
          this.dirty = !_.isEqual(this.$data.model, this.$data.oldModel)
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .input {
    margin: 10px auto;
  }

  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }

  .input.inline label {
    display: inline;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }

  .invalid label {
    color: red;
  }

  .invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }

  .icon_autotag {
	font-size:28px;
  }
   .right-panel {
	height: calc(100vh - 286px);
    overflow-y: auto;
    margin-left: 150px;
  }
  select.form-control:not([size]):not([multiple]) {
	height:auto;
  }
  textarea {
	padding: 7px 11px;
	height: 86px;
  }
  input {
	padding-left: 11px;
  }
  .module_heading .module_title {
	margin-left: 15px;
  }
  .create-asset-row {
    margin-bottom: 15px;
	width: 100%;
    float: left;
  }
  .text-label {
	float:left;
  }
  .result-btn {
	float:left;
	margin-left: 13px;
  }
  .continue {
	margin-left: 15px;
  }
  .ok {
	margin-left:10px;
  }
  .checkbox_fld {
    width: 20px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/app/learningContent/components/AssetCreate.vue